import React, { Component } from 'react';
import moment from 'moment';
import numeral from 'numeral';
import { connect } from 'shalala';

import './Dashboard.css';
import { useStore } from '../../store';
import StatisticCard from './components/StatisticCard';
import Loading from '../../facturotopia/loading/Loading';
import MonthlyHitsUsage from './components/MonthlyHitsUsage';
import MonthlyDetailedHitsUsage from './components/MonthlyDetailedHitsUsage';

class Dashboard extends Component {
  componentDidMount() {
    window.setAppTitle('Dashboard');

    this.props.summaryActions.summary({
      from: moment().startOf('month').toDate(),
      to: moment().toDate(),
    });
  }

  componentWillUnmount() {
    this.props.summaryActions.reset();
  }

  render() {
    const { busy, data } = this.props.summary;
    const {
      hits_available,
      hits_excel = null,
      hits_sector_primario = null,
      hits_consumed,
      invoices,
      cancellations,
      usage = {},
    } = data;

    const { labels = [], data: values = [], detailed = [] } = usage;

    return (
      <div className="dashboard">
        {!!busy && (
          <div className="text-center">
            <div className="col">
              <Loading />
            </div>
          </div>
        )}

        <div className="row pb-3">
          <div className="col text-left">
            <h4 className="text-muted">Mi consumo del mes</h4>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 pb-3">
            <StatisticCard
              variant="danger"
              title="Hits disponibles"
              icon={['fas', 'boxes']}
              text={numeral(hits_available).format('0,0')}
            />
          </div>

          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 pb-3">
            <StatisticCard
              variant="success"
              title="Hits consumidos"
              icon={['fas', 'box-open']}
              text={numeral(hits_consumed).format('0,0')}
            />
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 pb-3">
            <StatisticCard
              variant="warning"
              title="Facturas"
              icon={['far', 'file-alt']}
              text={numeral(invoices).format('0,0')}
            />
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 pb-3">
            <StatisticCard
              variant="purple"
              title="Cancelaciones"
              icon={['fas', 'weight-hanging']}
              text={numeral(cancellations).format('0,0')}
            />
          </div>
        </div>

        {(hits_excel !== null || hits_sector_primario !== null) && (
          <div className="row pb-3">
            <div className="col text-left">
              <h4 className="text-muted">Hits</h4>
            </div>
          </div>
        )}

        <div className="row">
          {hits_excel !== null && (
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 pb-3">
              <StatisticCard
                variant="success"
                title="Hits excel"
                icon={['fas', 'file-excel']}
                text={numeral(hits_excel).format('0,0')}
              />
            </div>
          )}

          {hits_sector_primario !== null && (
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 pb-3">
              <StatisticCard
                variant="warning"
                title="Hits sector primario"
                icon={['fas', 'file-alt']}
                text={numeral(hits_sector_primario).format('0,0')}
              />
            </div>
          )}
        </div>

        <div className="monthly-usage-chart">
          <MonthlyHitsUsage
            labels={labels}
            data={values}
          />
        </div>

        <div className="row mt-3">
          <div className="col table-responsive">
            <p className="text-muted">Detalles de mi consumo</p>
            <MonthlyDetailedHitsUsage data={detailed} />
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (store) => {
  return { summary: store.app.dashboard.summary };
};

const mapActions = (actions) => {
  return { summaryActions: actions.app.dashboard.summary };
};

export default connect(useStore, mapState, mapActions)(Dashboard);
